/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { OnePassItem } from 'client-code/previews';

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import {
    RESET_ONEPASS_LIST,
    SET_ONEPASS_MANAGER_IS_CARET_VISIBLE,
    SET_ONEPASS_MANAGER_IS_LIST_LOADED,
    SET_ONEPASS_MANAGER_LIST,
    SET_ONEPASS_MANAGER_OFFSET,
} from './onepassmanager.types';

export const resetOnePassListAction = (
    isScreenLoaded: boolean,
    lastSelectedPosition: number,
    offset: number,
    onePassList: Array<OnePassItem>,
    totalCount: number,
): TivoPayloadAction<{
    isScreenLoaded: boolean;
    lastSelectedPosition: number;
    offset: number;
    onePassList: Array<OnePassItem>;
    totalCount: number;
}> => ({
    type: RESET_ONEPASS_LIST,
    payload: { isScreenLoaded, lastSelectedPosition, offset, onePassList, totalCount },
});

export const setOnePassManagerIsCaretVisibleAction = (
    isCaretVisible: boolean,
): TivoPayloadAction<{ isCaretVisible: boolean }> => ({
    type: SET_ONEPASS_MANAGER_IS_CARET_VISIBLE,
    payload: { isCaretVisible },
});

export const setOnePassListOffsetAction = (
    offset: number,
): TivoPayloadAction<{ offset: number }> => ({
    type: SET_ONEPASS_MANAGER_OFFSET,
    payload: { offset },
});

export const setOnePassListValuesAction = (
    isScreenLoaded: boolean,
    onePassList: Array<OnePassItem>,
    totalCount: number,
): TivoPayloadAction<{
    isScreenLoaded: boolean;
    onePassList: Array<OnePassItem>;
    totalCount: number;
}> => ({
    type: SET_ONEPASS_MANAGER_LIST,
    payload: { isScreenLoaded, onePassList, totalCount },
});

export const setOnePassIsListLoadedAction = (
    isListLoaded: boolean,
): TivoPayloadAction<{
    isListLoaded: boolean;
}> => ({
    type: SET_ONEPASS_MANAGER_IS_LIST_LOADED,
    payload: { isListLoaded },
});
